import DashboardLayout from 'src/pages/Layout/DashboardLayout.vue';
import AuthLayout from 'src/pages/Pages/AuthLayout.vue';
// GeneralViews
import NotFound from 'src/pages/GeneralViews/NotFoundPage.vue';

// 网站设置
const SettingsView = () =>
  import( /* webpackChunkName: "extra" */ 'src/pages/Settings/SettingsView.vue');
// 网站设置
const CdkView = () =>
  import( /* webpackChunkName: "extra" */ 'src/pages/Cdk/CdkView.vue');
// 网站管理
const SiteView = () =>
  import( /* webpackChunkName: "extra" */ 'src/pages/Site/SiteView.vue');
// 用户管理
const UserView = () =>
  import( /* webpackChunkName: "extra" */ 'src/pages/UserInfo/UserView.vue');
  // 主页
const HomeView = () =>
import( /* webpackChunkName: "extra" */ 'src/pages/Home/HomeView.vue');
// 套餐管理
import Package from 'src/pages/Package/PackageView.vue';

// 登录界面
const Login = () =>
  import( /* webpackChunkName: "pages" */ 'src/pages/Pages/Login.vue');


// 在线支付
const PayInfo = () =>
  import( /* webpackChunkName: "pages" */ 'src/pages/PayInfo/PayView.vue');
// 在线支付
const Record = () =>
  import( /* webpackChunkName: "pages" */ 'src/pages/DownloadRecord/DownloadRecord.vue');

// let pagesMenu = {
//   path: '/pages',
//   component: DashboardLayout,
//   name: 'Pages',
//   redirect: '/pages/user',
//   children: [{
//       path: 'user',
//       name: 'User Page',
//       components: {
//         default: User
//       }
//     },
//     {
//       path: 'timeline',
//       name: 'Timeline Page',
//       components: {
//         default: TimeLine
//       }
//     },
//     {
//       path: 'rtl',
//       name: 'RTL Page',
//       components: {
//         default: RTL
//       }
//     }
//   ]
// };

let authPages = {
  path: '/',
  component: AuthLayout,
  name: 'Authentication',
  children: [{
      path: '/login',
      name: 'Login',
      component: Login
    }
  ]
};

const routes = [{
    path: '/',
    redirect: '/home',
    name: 'Home1'
  },
  // pagesMenu,
  authPages,
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/dashboard',
    name: 'Dashboard layout',
    children: [
      {
        path: 'settings',
        name: '网站设置',
        components: {
          default: SettingsView
        }
      },
      {
        path: 'package',
        name: '套餐管理',
        components: {
          default: Package
        }
      },
      {
        path: 'cdk',
        name: '卡密管理',
        components: {
          default: CdkView
        }
      },
      {
        path: 'site',
        name: '网站管理',
        components: {
          default: SiteView
        }
      },
      {
        path: 'user',
        name: '用户管理',
        components: {
          default: UserView
        }
      },
      {
        path: 'home',
        name: '主页',
        components: {
          default: HomeView
        }
      },
      {
        path: 'payInfo',
        name: '在线支付',
        components: {
          default: PayInfo
        }
      },
      {
        path: 'record',
        name: '下载记录',
        components: {
          default: Record
        }
      },
      
    ]
  },
  {
    path: '*',
    component: NotFound
  }
];

export default routes;
